<wdx-form-field
    [label]="formInputData?.label | translateTokenisedString"
    [isRequired]="formInputData?.isRequired"
    [isSensitive]="formInputData?.isSensitive"
    [guidanceText]="formInputData?.guidanceText | translateTokenisedString"
    [validationErrorMessage]="validationErrorMessage"
>
    <div
        class="input-group lookup-container form-control p-0"
        [class.is-invalid]="validationErrorMessage"
    >
        <button
            class="btn btn-primary"
            type="button"
            tabindex="0"
            [class.is-invalid]="validationErrorMessage"
            (click)="onOpen()"
            (blur)="blurred.emit()"
            [disabled]="formInputData?.isDisabled"
        >
            <wdx-icon [icon]="UTILS_ICON_SEARCH"></wdx-icon>
        </button>
        @if (lookupCards?.length) {
            <div
                class="flex-1 form-control border-0 lookup-button"
                [attr.data-cy]="
                    'action-' + (formInputData?.name || formInputData?.id)
                "
                [ngClass]="{
                    'p-0': formViewType === 'grid',
                    'is-invalid': validationErrorMessage,
                }"
            >
                @if (formViewType === 'grid') {
                    @let columnDefs = columnDefs$ | ngrxPush;
                    <div
                        class="grid-container"
                        [ngClass]="{
                            'grid-container--three-rows': val?.length === 3,
                            'grid-container--four-rows': val?.length === 4,
                            'grid-container--five-plus-rows': val?.length > 4,
                            'opacity-50': formInputData?.isDisabled,
                        }"
                    >
                        @if (inlineGridQuery) {
                            <wdx-ag-grid-entity-table
                                [gridOptions]="gridOptions"
                                [columnDefs]="columnDefs"
                                [entityType]="entityType"
                                [pageSize]="200"
                                [queryExpressions]="inlineGridQuery"
                            ></wdx-ag-grid-entity-table>
                        }
                    </div>
                } @else if (formViewType === 'lookups') {
                    <clmi-lookup-selected-items
                        [lookupCards]="lookupCards"
                        [disabled]="formInputData?.isDisabled"
                        (deleteItem)="deleteItem($event)"
                    ></clmi-lookup-selected-items>
                }
            </div>
        } @else {
            <button
                class="d-flex h-100 w-100 ps-2 align-items-center justify-content-start flex-1 form-control border-0"
                [class.is-invalid]="validationErrorMessage"
                (click)="onOpen()"
                (blur)="blurred.emit()"
                [disabled]="formInputData?.isDisabled"
            >
                <span class="placeholder">
                    {{
                        formInputData?.placeholder
                            ? (formInputData.placeholder
                              | translateTokenisedString)
                            : '&nbsp;'
                    }}
                </span>
            </button>
        }
    </div>
</wdx-form-field>
